module.exports = __webpack_public_path__ + "img/mangoerp.6e3ad702.png";